import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { PurchaseOrderSalesAllocation } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderSalesAllocationService extends TmsWebBaseEditCreateService<
  PurchaseOrderSalesAllocation,
  PurchaseOrderSalesAllocation
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('PurchaseOrderSalesAllocation', $localize`Purchase Order Sales Allocation`);
  }

  allocate(purchaseOrderLineId: string, salesOrderLineId: string): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Allocate`, {
      purchaseOrderLineId,
      salesOrderLineId,
    });
  }

  updatePurchaseOrderSalesAllocation(purchaseOrderSalesAllocationId: string, quantity: number) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateSalesOrderPurchaseAllocation`, {
      purchaseOrderSalesAllocationId,
      quantity,
    });
  }

  getAllocations(purchaseOrderLineId: any): Observable<PurchaseOrderSalesAllocation[]> {
    return this.httpService.get<PurchaseOrderSalesAllocation[]>(
      `${this.apiUrl}/GetAllocations?purchaseOrderLineId=${purchaseOrderLineId}`,
    );
  }
}
